import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_CLIMATE_STRIKE_LOGO = createFcmConfig('enable_climate_strike_logo', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
